/**
 * The hex at the centre of the map view, from the renderer's `camera` reports. The report is
 * remembered at module level, so a component mounting after the first frame still knows it.
 */
import { type HexId, NO_HEX } from '@friction/engine';
import { useEffect, useState } from 'react';
import { type BusEvents, bus } from '../../game/bus';
import { useGame } from '../../game/store';

let last: BusEvents['camera'] | null = null;
bus.on('camera', (c) => {
  last = c;
});

export function useCameraHex(): HexId {
  const grid = useGame((g) => g.grid);
  const centre = (c: BusEvents['camera'] | null): HexId =>
    grid && c ? grid.fromWorld(c.x + c.width / 2, c.y + c.height / 2) : NO_HEX;
  const [hex, setHex] = useState<HexId>(() => centre(last));
  // biome-ignore lint/correctness/useExhaustiveDependencies: centre only closes over grid
  useEffect(() => {
    setHex(centre(last));
    return bus.on('camera', (c) => setHex(centre(c)));
  }, [grid]);
  return hex;
}
